import stateManager from '../../../../modules/user/stateManager';
import { openModal as openVirtualServiceModal } from './VirtualServiceEducationModal';
import analytics from '../../../../modules/analytics';

const LAST_SHOWN_KEY = 'last-virtual-service-pop';
let isChecking = false;

// eslint-disable-next-line
export const markVirtualServiceAnnouncementAsRead = () => stateManager.addAction(LAST_SHOWN_KEY, Date.now());

export const onReceiveNotifications = async (notifications, modalContext) => {
  const virtualServiceNotification = notifications.find(
    n => n.type === 'virtual_services_education',
  );
  if (virtualServiceNotification && !isChecking) {
    isChecking = true;
    const lastShown = await stateManager.getActionValue(LAST_SHOWN_KEY);
    isChecking = false;
    if (!lastShown) {
      analytics.track('virtual_service_education_modal_first_launch_view');
      markVirtualServiceAnnouncementAsRead();
      return openVirtualServiceModal(modalContext, virtualServiceNotification);
    }
  }
  return null;
};
